import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MaterialPersianDateAdapter, PERSIAN_DATE_FORMATS} from './material.persian-date.adapter';

@Component({
  selector: 'morva-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MaterialPersianDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: PERSIAN_DATE_FORMATS },
  ],
})
export class DatePickerComponent implements OnInit,OnChanges {
  @Output() changeExpirationDate = new EventEmitter();
  @Input() expirationTicks;
  expirationDate: Date;


  ngOnChanges(changes: SimpleChanges): void {
    if(!changes['expirationDate']?.firstChange) {
      this.ticksToDateExpiration();
    }
  }

  ngOnInit() {
    this.ticksToDateExpiration();
  }

  ticksToDateExpiration() {
    if (this.expirationTicks === 3155378976000000000) {
      this.expirationDate = new Date('2025, 11, 08');
    } else {
      const ticksToDate = require('ticks-to-date');
      this.expirationDate = ticksToDate(this.expirationTicks);
    }
  }

  emitExpirationDate(event: MatDatepickerInputEvent<Date>) {
    const utcDate = new Date(event.value['_d'].toUTCString()).getTime();
    const expirationTicks = utcDate * 10000 + 621355968000000000;
    this.changeExpirationDate.emit(expirationTicks);
  }
}
